<template>
  <v-content>
    <router-view style="min-height: calc(100vh - 161px);" />

    <dashboard-core-footer v-if="$store.state.loggedIn && !['/login', '/signup'].includes($route.fullPath)" />
  </v-content>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
    },
  }
</script>
